export const siteSettings = {
  name: "Cite Finex",
  link: "https://citefinex.com",
  email: "support@citefinex.com",
  appLink: "https://app.citefinex.com",
};
